import { EnquiryLifecycleStatusEnum } from "../enum";

export class EnquiryAssessmentUpdateReq{
    id: number;
    status: EnquiryLifecycleStatusEnum;
    rejectReason : number;
    createdUser: string;
    rejectReasonName?: string;
    rejectDescription?:string

    constructor(id:number,status:EnquiryLifecycleStatusEnum,rejectReason : number,createdUser: string,rejectReasonName?: string,    rejectDescription?:string
    ){
        this.id = id;
        this.status = status
        this.rejectReason = rejectReason
        this.createdUser = createdUser
        this.rejectReasonName = rejectReasonName
        this.rejectDescription=rejectDescription
    }
}